import React from "react";
import { Box, CircularProgress, Switch, Tooltip, Typography } from "@mui/material";
import { PASTEL } from "./livechatTheme";

// DEV-1234 AC-1 — toggle "Autoleads" (dulu "Bersedia Menerima Lead Baru"). Hanya dirender parent kalau agent eligible
// (memegang minimal 1 brand dengan autoAssignEnabled), jadi user Corporate/mitra tidak pernah melihatnya.
// DEV-1238 — `locked`: autoleads dimatikan admin (override) -> switch nonaktif, sales tidak bisa menyalakan.
export default function LeadAvailabilityToggle({ checked, saving, onChange, compact, locked, lockedByName }) {
    return (
        <Tooltip
            title={
                locked
                    ? `Autoleads Anda dinonaktifkan oleh ${lockedByName || "admin"}. Hubungi admin untuk menyalakan kembali.`
                    : checked
                        ? "Anda ikut antrian pembagian percakapan baru secara bergiliran"
                        : "Nyalakan supaya ikut kebagian percakapan baru secara bergiliran"
            }
        >
            <Box
                sx={{
                    display: "flex", alignItems: "center", gap: 0.5, pl: 1.25, pr: 0.5, py: 0.25,
                    borderRadius: 5, border: `1px solid ${checked ? PASTEL.primary : PASTEL.border}`,
                    backgroundColor: checked ? PASTEL.primarySoft : "transparent",
                }}
            >
                {!compact && (
                    <Typography variant="caption" sx={{ fontWeight: 600, color: checked ? PASTEL.primary : "text.secondary", whiteSpace: "nowrap" }}>
                        {locked ? "Lead Dinonaktifkan Admin" : "Autoleads"}
                    </Typography>
                )}
                {saving ? (
                    <CircularProgress size={16} sx={{ color: PASTEL.primary, mx: 1.25 }} />
                ) : (
                    <Switch
                        size="small"
                        checked={checked}
                        disabled={locked}
                        onChange={(e) => onChange(e.target.checked)}
                        inputProps={{ "aria-label": "Autoleads" }}
                        sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": { color: PASTEL.primary },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: PASTEL.primary },
                        }}
                    />
                )}
            </Box>
        </Tooltip>
    );
}
